import { EnrollmentStatus } from "../types/client-education-detail.types";
import type { EnrollmentDto } from "../types/client-education-detail.types";

export type AccessMode =
  | "catalog"
  | "pending"
  | "rejected"
  | "cancelled"
  | "trainee"
  | "completing"
  | "notCompleted"
  /**
   * Eğitimin/sanal sınıfın eğitmeni. Enrollment kaydı yoktur; bu yüzden
   * `resolveAccessMode` bu modu üretemez — çağıran taraf backend'in
   * `isInstructor` bayrağıyla belirler (bkz. ClientEducationDetailPage).
   * İçerik ve sanal sınıf görünür, kursiyere özel adımlar (yoklama, sınav,
   * anket, sertifika) gösterilmez.
   */
  | "instructor";

export function resolveAccessMode(enrollment: EnrollmentDto | null | undefined): AccessMode {
  if (!enrollment) return "catalog";
  switch (enrollment.status) {
    case EnrollmentStatus.REQUESTED:
    case EnrollmentStatus.APPROVED_BRANCH_MANAGER:
    case EnrollmentStatus.APPROVED_BY_EDUCATION_SUPERVISOR:
      // Başvurmuş / onay sürecindeki kullanıcı (henüz ENROLLED değil) — eğitime
      // "düşmedi", başvuru sürecinde kalır; eğitim içeriğini görmez.
      return "pending";
    // REJECTED_BY_EDUCATION_SUPERVISOR (ilk adım reddi) burada eksikti; kayıt
    // default'a düşüp kursiyere "reddedildi" ekranı yerine katalog görünümü
    // çıkıyordu — tekrar başvuru butonuna da ulaşılamıyordu.
    case EnrollmentStatus.REJECTED_BY_BRANCH_MANAGER:
    case EnrollmentStatus.REJECTED_BY_CENTRAL_MANAGER:
    case EnrollmentStatus.REJECTED_BY_EDUCATION_SUPERVISOR:
      return "rejected";
    case EnrollmentStatus.CANCELLED:
      return "cancelled";
    case EnrollmentStatus.ENROLLED:
      return "trainee";
    case EnrollmentStatus.NOT_COMPLETED:
      return "notCompleted";
    case EnrollmentStatus.CONTENT_COMPLETED:
    case EnrollmentStatus.EXAM_FAILED:
    case EnrollmentStatus.EXAM_COMPLETED:
    case EnrollmentStatus.COMPLETED:
    case EnrollmentStatus.EXAM_STARTED:
    case EnrollmentStatus.SURVEY_STARTED:
      return "completing";
    default:
      return "catalog";
  }
}
